import FlintDialog from "./FlintDialog";
import {MouseEventHandler, ReactNode, useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import FlintButton from "../FlintButton";
import {bool} from "yup";

export default function FlintDialogConfirm(props: flintDialogConfirmProps) {
    const {t} = useTranslation();
    const dialogActionButtons = (<>
        <FlintButton themeColor={"secondary"} type="button" onClick={props.onCancel} disabled={props.isLoading}
                     showLoadingIcon={props.isLoading}>
            {props.cancelButtonText ? props.cancelButtonText : t("COMMON_No")}
        </FlintButton>
        {props.onAccept !== undefined &&
        <FlintButton themeColor={"primary"} type="button" onClick={props.onAccept} disabled={props.isLoading}
                     showLoadingIcon={props.isLoading}>
            {props.acceptButtonText ? props.acceptButtonText : t("COMMON_Yes")}
        </FlintButton>}
    </>);
    return( 
        <FlintDialog {...props} dialogActionButtons={dialogActionButtons} onClose={props.onCancel}
                      className={props.isLoading ? "is-loading" : ""}>
            <div style={{textAlign: "center"}}>
                {props.content}
            </div>
        </FlintDialog>
    );
}

export interface flintDialogConfirmProps {
    content: ReactNode;
    onAccept?: () => void | Promise<void>;
    onCancel?: () => void;
    title?: string;
    acceptButtonText?: string;
    cancelButtonText?: string;
    isLoading?: boolean;
}